Hop.defineModule('ariaAlert', (root) => {
    const $root = $(root);
    setTimeout(() => {
        $root.attr('role', 'alert');
    }, 1000);
});
